export const pageToSkip = (page: number, limit: number): number => {
  return page * limit;
};
